import { TextField, MenuItem } from '@mui/material'
import React from 'react'
import { User } from '../../interfaces'

interface PickerValidatorFilterProps {
  pickers: User[]
  handleChange: (
    e: React.ChangeEvent<{
      name?: string
      value: unknown
    }>
  ) => void
  value: number
}

export const PickerValidatorFilter: React.FC<PickerValidatorFilterProps> = ({
  pickers,
  handleChange,
  value
}) => {
  return (
    <TextField
      onChange={handleChange}
      id='validationUserId'
      name='validationUserId'
      value={value}
      variant='outlined'
      select
      fullWidth
    >
      <MenuItem value={0}>Seleccione Validador</MenuItem>
      {pickers.map(({ userId, userAlias }) => (
        <MenuItem value={userId}>{userAlias}</MenuItem>
      ))}
    </TextField>
  )
}
